import { useState } from "react";
import { PerformanceDetailsService } from "../../application/services/performanceDetailsService";

const performanceDetailsService = new PerformanceDetailsService();

export const usePerformanceDetails = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dailyCpuData, setDailyCpuData] = useState(null);
  const [dailyRamData, setDailyRamData] = useState(null);
  const [dailyAvailableRamData, setDailyAvailableRamData] = useState(null);
  const [dailyMetricsData, setDailyMetricsData] = useState(null);

  const getVmDailyCpu = async (vmId, date) => {
    setLoading(true);
    setError(null);
    try {
      const result = await performanceDetailsService.getVmDailyCpu(vmId, date);
      if (result.success) {
        setDailyCpuData(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const getVmDailyRam = async (vmId, date) => {
    setLoading(true);
    setError(null);
    try {
      const result = await performanceDetailsService.getVmDailyRam(vmId, date);
      if (result.success) {
        setDailyRamData(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const getVmDailyAvailableRam = async (vmId, date) => {
    setLoading(true);
    setError(null);
    try {
      const result = await performanceDetailsService.getVmDailyAvailableRam(vmId, date);
      if (result.success) {
        setDailyAvailableRamData(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const getVmDailyMetrics = async (vmId, date) => {
    setLoading(true);
    setError(null);
    try {
      const result = await performanceDetailsService.getVmDailyMetrics(vmId, date);
      if (result.success) {
        setDailyMetricsData(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  return {
    getVmDailyCpu,
    getVmDailyRam,
    getVmDailyAvailableRam,
    getVmDailyMetrics,
    dailyCpuData,
    dailyRamData,
    dailyAvailableRamData,
    dailyMetricsData,
    loading,
    error,
  };
};